import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { placeOrderReport } from "@/api/PMS/report/placeReport.js";
import waves from "@/directive/waves"; // 水波纹指令

import { formatJson } from "@/utils/index";
export default {
  name: "ProReport",
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      dates: [],
      multipleSelection: []
    };
  },
  created: function created() {
    this.defaultDate(); // 获取路由的配置
    // let appType = this.$route.query.appType;
    // if (appType !== undefined) {
    //   this.listQuery.appType = parseInt(appType);
    // }

    this.getList();
  },
  methods: {
    cellClassName: function cellClassName(data) {
      if (data.columnIndex === 1) {
        return 'dayTimeCss';
      }
    },
    selectDayTime: function selectDayTime(time) {
      this.$router.push({
        path: "/tickets/detail",
        query: {
          dates: [time, time]
        }
      });
    },
    // 初始化默认时间
    defaultDate: function defaultDate() {
      var date = new Date();
      var year = date.getFullYear().toString();
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
      var day = new Date(date.getFullYear(), month, 0).getDate();
      day < 10 ? '0' + day.toString() : day.toString();
      var beg = year + '-' + month + '-01';
      var end = year + '-' + month + '-' + day;
      this.dates = [beg, end];
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = "";
        this.listQuery.endDate = "";
      }

      placeOrderReport(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出
    handleExport: function handleExport() {
      var _this2 = this;

      this.exLists = [];
      this.$confirm("你确定要导出场地预约订单统计吗, 是否继续?", "提示").then(function () {
        var beginDate = "";
        var endDate = "";

        if (_this2.dates !== null && _this2.dates.length > 0) {
          beginDate = _this2.dates[0];
          endDate = _this2.dates[1];
        }

        placeOrderReport({
          endDate: endDate,
          beginDate: beginDate
        }).then(function (response) {
          var list = response.data.data;

          if (list !== null && list.length > 0) {
            var arrayWithIndex = list.map(function (item, index) {
              return _objectSpread({
                index: index + 1
              }, item);
            });
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require("@/vendor/Export2Excel"));
            }).then(function (excel) {
              var tHeader = ["序号", "日期", "零售场次", "固定场次", "公益比赛场次", "非公益比赛场次"];
              var fileterVal = ["index", "dayTime", "retail", "fixed", "publicWelfare", "nonPublicWelfare"];
              var multiHeader = [["场地预约订单统计", "", "", "", "", ""]];
              var merges = ["A1:F1"];
              var data = formatJson(fileterVal, arrayWithIndex);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                merges: merges,
                multiHeader: multiHeader,
                filename: "场地预约订单统计",
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          } else {
            _this2.Alert({
              alertType: "error",
              message: "暂无数据，无法导出！"
            });
          }
        });
      });
    }
  }
};